/* eslint-disable */
export default {
    cp_profile_details_saved: "Je gegevens zijn opgeslagen",
    cp_profile_details_not_saved: "Je wijzigingen zijn nog niet opgeslagen",
    cp_profile_logout: "Log uit",
    cp_profile_general_error: "Er is een fout opgetreden. Probeer het opnieuw.",
    cp_profile_save: "Opslaan",
    cp_profile_first_name: "Voornaam",
    cp_profile_infix: "Tussenvoegsel",
    cp_profile_last_name: "Achternaam",
    cp_profile_gender: "Geslacht",
    cp_profile_male: "Man",
    cp_profile_female: "Vrouw",
    cp_profile_other: "Anders",
    cp_profile_settings_email_on_report_permissions: "Melding ontvangen wanneer deelnemer toestemming wijzigt voor het delen van het rapport",
    cp_profile_unspecified: "Dat zeg ik liever niet",
    cp_profile_language_preference_success: "Taalvoorkeur succesvol opgeslagen",
    cp_profile_language_preference_failed: "Kon taalvoorkeur niet opslaan"
};
